import React, { useState } from "react";
import { Icon } from "../../Component";
import DatePicker, { registerLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB";
import YearsDropDown from "../../dropdowns/YearsDropDown";
import MonthDropDown from "../../dropdowns/MonthDropDown";
import moment from "moment/moment";
import { MONTHS } from "../../../utils/Utils";
import { bottomStartDatePickerPopperModifiers } from "./datePickerPopperModifiers";

registerLocale(enGB);

const FormDatePicker = ({
  selected,
  onChange,
  maxDate,
  minDate,
  error,
  showMonthYearPicker,
  numberOfPastYears,
  disabled,
  isClearable = false,
  placeholderText = "Select a date",
  includeDates,
}) => {
  const [year, setYear] = useState();
  const [month, setMonth] = useState();

  const handleClear = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) {
      onChange(null);
    }
  };

  return (
    <div className={`form-control-wrap form-date-picker${isClearable ? " form-date-picker-clearable" : ""}`}>
      <div className="input-group">
        <div className="input-group-prepend w-100 position-relative">
          <Icon className="input-group-text" name="calender-date" />
          <DatePicker
            locale={enGB}
            selected={selected}
            onChange={onChange}
            placeholderText={placeholderText}
            dateFormat={showMonthYearPicker ? "MMMM yyyy" : "dd-MM-yyyy"}
            formatWeekDay={(dayName) => dayName.slice(0, 2)}
            className={`form-control rounded-0 rounded-end border-start-0${isClearable ? " form-date-picker-input-clearable" : ""}`}
            showMonthYearPicker={showMonthYearPicker}
            maxDate={maxDate}
            minDate={minDate}
            disabled={disabled}
            includeDates={includeDates}
            popperPlacement="bottom-start"
            popperModifiers={bottomStartDatePickerPopperModifiers}
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              decreaseYear,
              increaseYear,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
              prevYearButtonDisabled,
              nextYearButtonDisabled,
            }) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <span className="">
                  <div className="input-group">
                    <span
                      className="input-group-text px-1"
                      onClick={() => {
                        if (showMonthYearPicker) {
                          decreaseYear();
                        } else {
                          decreaseMonth();
                          setMonth();
                        }
                        setYear();
                      }}
                      disabled={showMonthYearPicker ? prevYearButtonDisabled : prevMonthButtonDisabled}
                    >
                      <Icon className="" name="chevron-left" />
                    </span>
                    <YearsDropDown
                      value={
                        year ?? {
                          id: "",
                          value: moment(date).format("YYYY"),
                          label: moment(date).format("YYYY"),
                        }
                      }
                      placeholder={"years"}
                      className="w-100px"
                      numberOfPastYears={numberOfPastYears}
                      minDate={minDate}
                      maxDate={maxDate}
                      onSelect={(e) => {
                        setYear(e);
                        changeYear(e?.value);
                      }}
                    />
                    {!showMonthYearPicker && (
                      <MonthDropDown
                        value={month}
                        placeholder={"months"}
                        className="w-120px"
                        selectedValue={MONTHS.find((item) => item.value === moment(date).format("MMMM"))}
                        onSelect={(e) => {
                          setMonth(e);
                          changeMonth(e?.id - 1);
                        }}
                      />
                    )}
                    <span
                      className="input-group-text px-1"
                      onClick={() => {
                        if (showMonthYearPicker) {
                          increaseYear();
                        } else {
                          increaseMonth();
                          setMonth();
                        }
                        setYear();
                      }}
                      disabled={showMonthYearPicker ? nextYearButtonDisabled : nextMonthButtonDisabled}
                    >
                      <Icon className="" name="chevron-right" />
                    </span>
                  </div>
                </span>
              </div>
            )}
          />
          {isClearable && (
            <div className="form-date-picker-indicators">
              {selected && (
                <button
                  type="button"
                  className="form-date-picker-clear"
                  onClick={handleClear}
                  aria-label="Clear"
                  disabled={disabled}
                >
                  <Icon name="cross" />
                </button>
              )}
              <span className="form-date-picker-dropdown">
                <Icon name="chevron-down" />
              </span>
            </div>
          )}
        </div>
      </div>
      {error && <span className="invalid">{error}</span>}
    </div>
  );
};

export default FormDatePicker;
